import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, useForm } from 'react-hook-form';
import { FormFields, formSchema } from '../types/formSchema';
import { TextField } from '@mui/material';
import { useFlow } from '../hooks/useFlow';
import { useReceptionInfo } from '../hooks/useReceptionInfo';
import { DUMMY } from '../const/dummy';
import Layout from './Layout';
import Call from './Call';
import { textFieldStyle } from '../const/textFieldStyle';
import { ClinicProps } from '../types/Props';

function InputNumberForm({ clinicName }: ClinicProps) {
  const { setFlow } = useFlow();
  const { setReceptionNumber } = useReceptionInfo();
  const form = useForm<FormFields>({
    resolver: yupResolver(formSchema)
  });
  const handleSubmit = ({ receptionNumber }: FormFields) => {
    if (DUMMY.some(({ id }) => id === receptionNumber)) {
      setFlow('finished');
      setReceptionNumber(receptionNumber as string);
    }
  };

  return (
    <Layout flowName="診察券番号入力" clinicName={clinicName || undefined}>
      <p className="text-2xl sm:text-3xl font-bold text-gray-500 my-14 text-center">診察券番号を入力してください</p>
      <form onSubmit={form.handleSubmit(handleSubmit)} className="mt-8">
        <Controller
          name="receptionNumber"
          control={form.control}
          render={({ field, fieldState }) => (
            <TextField
              {...field}
              type="text"
              label="診察券番号"
              error={fieldState.invalid}
              helperText={fieldState.error?.message}
              value={field.value ?? ''}
              variant="outlined"
              autoFocus
              sx={textFieldStyle}
              className="w-full"
            />
          )}
        />
        <Call className="mt-12" />
      </form>
    </Layout>
  );
}

export default InputNumberForm;
